<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card>
        <div slot="title"><a-icon type="file-search" />Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse :activeKey="getScreen ? 0 : 1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label>Transaction Date</label>
                  <a-range-picker :placeholder="['Start Date', 'End Date']" v-model="transactionDt" :format="dateFormat"
                    allowClear />
                </div>
                <div class="m-form-item-wrapper">
                  <label>Category</label>
                  <a-select placeholder="Ex: Value's < 50 Million Rupiah" v-model="kategori" class="width-full"
                    initialValue="null" allowClear>
                    <a-select-option value="less">Value's &#60; 50 Million Rupiah</a-select-option>
                    <a-select-option value="over">Value's &#62;= 50 Million Rupiah</a-select-option>
                  </a-select>
                </div>
                <div class="m-form-item-wrapper">
                  <label>WorkFlow Status</label>
                  <a-select placeholder="Ex: Not Closed... " v-model="statusWorflow" class="width-full"
                    initialValue="Not Closed" allowClear>
                    <a-select-option value="Opened">Not Closed</a-select-option>
                    <a-select-option value="Closed">Closed</a-select-option>
                  </a-select>
                </div>
                <div class="m-form-item-wrapper">
                  <label>Transaction Status</label>
                  <a-select placeholder="Ex: Approved ... " v-model="status" class="width-full" initialValue="delivered"
                    allowClear>
                    <a-select-option value="delivered">Delivered</a-select-option>
                    <a-select-option value="approved">Approved</a-select-option>
                    <a-select-option value="on process">On Process</a-select-option>
                    <a-select-option value="revised">Revised</a-select-option>
                    <a-select-option value="rejected">Rejected</a-select-option>
                    <a-select-option value="transferred">Transferred</a-select-option>
                    <a-select-option value="closed">Closed</a-select-option>
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataList :loading="loading" title="UM PD List" :manifestLink="getManifestLink" :dataList="umpdSearch"
        :disabledCreateEditLink="true" :isMonitoring="true" />
    </a-col>
  </a-row>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import _ from "lodash";

export default {
  name: "umpd",
  mixins: [CurrencyFormat],
  data() {
    return {
      loading: true,
      dateFormat: "DD MMM YYYY",
      umList: [],
      search: "",
      tempList: "",
      kategori: undefined,
      statusWorflow: undefined,
      status: undefined,
      transactionDt: [],
      form: this.$form.createForm(this),
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 5,
        size: "small",
      },
    };
  },
  mounted() {
    this.fetchData();
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    umpdSearch() {
      var self = this;
      let outputData = this.umList;

      if (this.search) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.searchQ &&
            obj.searchQ.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (this.kategori) {
        outputData = outputData.filter((item) => {
          return this.kategori == "less" ? item.realisasirp < 50000000 : item.realisasirp >= 50000000;
        });
      }

      if (this.statusWorflow) {
        outputData = _.filter(outputData, (item) => {
          return (
            item.isclosed.toLowerCase() == self.statusWorflow.toLowerCase()
          );
        });
      }

      if (this.status) {
        if (this.status == "closed") {
          outputData = _.filter(
            outputData,
            (obj) =>
              obj.endStatus &&
              obj.endStatus.toLowerCase().indexOf(this.status.toLowerCase()) >= 0
          );
        } else {
          outputData = _.filter(
            outputData,
            (obj) =>
              obj.status &&
              obj.status.toLowerCase().indexOf(this.status.toLowerCase()) >= 0
          );
        }
      }

      if (self.transactionDt.length > 0) {
        let startDt = moment(self.transactionDt[0]).format(
          this.getStandartFormatDate
        );
        let endDt = moment(self.transactionDt[1]).format(
          this.getStandartFormatDate
        );
        outputData = _.filter(
          outputData,
          (obj) => obj.tgl_buat >= startDt && obj.tgl_buat <= endDt
        );
      }

      return outputData;
    },
    getManifestLink() {
      let manifest = "";
      if (localStorage.getItem("nvpn") === "/keuangan") {
        manifest = "SpclUMPDManifestKeu";
      } else if (localStorage.getItem("nvpn") === "/pimpro") {
        manifest = "SpclUMPDManifestPimpro";
      } else if (localStorage.getItem("nvpn") === "/atasanLangsung") {
        manifest = "SpclUMPDManifestAL";
      } else if (localStorage.getItem("nvpn") === "/direktur") {
        manifest = "SpclUMPDManifestDir";
      } else if (localStorage.getItem("nvpn") === "/akuntansiKeuangan") {
        manifest = "SpclUMPDManifestAcc";
      } else if (localStorage.getItem("nvpn") === "/vpf") {
        return "SpclUMPDManifestVpf";
      } else if (localStorage.getItem("nvpn") === "/FinancialControl") {
        return "SpclUMPDManifestFin";
      } else if (localStorage.getItem("nvpn") === "/marketing") {
        return "SpclUMPDManifestMar";
      } else {
        manifest = "SpclUMPDManifest_";
      }
      return manifest;
    },
  },
  methods: {
    moment,
    fetchData() {
      axios({
        method: "get",
        url: this.$serviceUrl + "monitoring/umpds",
        params: {
          id: localStorage.getItem("nvky"),
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          _.forEach(response.data.data, (data) => {
            const date = this.moment(data.tgl_buat).format(
              this.getDefaultDateFormat
            );
            this.umList.push({
              title: data.no_um,
              subdesc: [
                [
                  {
                    label: date,
                    value: "",
                  },
                ],
                [
                  {
                    label: data.deskripsi,
                    value: "",
                  },
                ],
                [
                  {
                    label: "Estimated value",
                    value: this.formatCurrency(data.currency, data.value_um),
                  },
                ],
                [
                  {
                    label: "Realization value",
                    value:
                      data.realisasi == "0"
                        ? "There are no reports yet"
                        : this.formatCurrency(data.currency, data.realisasi),
                  },
                ],
              ],
              timeline: JSON.parse(data.status_app),
              unread: data.unread == "1" ? true : false,
              status: data.status,
              endStatus: data.isclosed,
              peruntukan: data.peruntukan,
              isclosed: data.isclosed,
              id: data.id_um,
              tgl_buat: data.tgl_buat,
              searchQ:
                data.no_um +
                " " +
                data.deskripsi +
                " " +
                data.value_um +
                " " +
                data.realisasi,
              realisasirp: data.realisasirp,
            });
          });

          this.loading = false;
        })
        .catch((err) => {
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
  },
};
</script>